import React, { useMemo, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { DocumentSectionKPI } from "store/types/documents";

import { State } from "./CreateReportSection";
import { KPI } from "./KPI";

interface Props {
  data: DocumentSectionKPI["report_data"]["settings"][number][];
  onSubmit: (data: Props["data"]) => void;
  onCancel: () => void;
}

export const EditKPIs: React.FC<Props> = ({ data, onSubmit, onCancel }) => {
  const [state, setState] = useState<State["kpi"]>(
    data.map((item, index) => ({ ...item, id: index + 1, isDeleted: false }))
  );

  const isDisabledSubmit = useMemo(() => {
    return state.filter((item) => !item.isDeleted).some((item) => !item.title || !item.filter);
  }, [state]);

  const handleSubmit = () => {
    onSubmit(state.filter((item) => !item.isDeleted).map((item) => ({ title: item.title, filter: item.filter })));
  };

  return (
    <Stack
      sx={{
        outline: "none",
        bgcolor: "white",
        minWidth: 300,
        p: "32px",
        gap: "20px",
        borderRadius: "8px",
        borderShadow: "sm",
        maxHeight: "500px",
        overflow: "hidden"
      }}
    >
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #DBE8F5" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: 400, lineHeight: "24px" }}>Edit KPIs</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack sx={{ overflow: "auto", pt: "6px" }}>
        <KPI data={state} setData={setState} />
      </Stack>
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "8px" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={isDisabledSubmit}>
          Confirm
        </Button>
      </Stack>
    </Stack>
  );
};
